import { CustomerResponse } from '@/types/api/v1/CustomerInfoResponse';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

const url = ApiUrl.Read.CUSTOMER_INFO;

const useGetCustomerInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<CustomerResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetCustomerInfo;
